import {
    ADDORUPDATEMODULEMASTERFORADMIN_SUCCESS,
    ADDORUPDATEMODULEMASTERFORADMIN_FAILED,
    RESET_ADDORUPDATEMODULEMASTERFORADMIN,
    LOADING_ADDORUPDATEMODULEMASTERFORADMIN,
    NETWORK_ERROR_ADDORUPDATEMODULEMASTERFORADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAddOrUpdateModuleMasterForAdminList = () => {
    return { type: RESET_ADDORUPDATEMODULEMASTERFORADMIN };
};

const AddOrUpdateModulesMasterAdminLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATEMODULEMASTERFORADMIN });
    await adminServices
        .post("addOrUpdateModulemasterforadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(addOrUpdateModuleMasterAdminListsuccess(res.data));
                    break;
                default:
                    dispatch(addOrUpdateModuleMasterAdminListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDORUPDATEMODULEMASTERFORADMIN,
                payload: err
            });
        });
};


function addOrUpdateModuleMasterAdminListsuccess(data) {
    return {
        type: ADDORUPDATEMODULEMASTERFORADMIN_SUCCESS,
        payload: data
    };
}
function addOrUpdateModuleMasterAdminListFailed(data) {
    return {
        type: ADDORUPDATEMODULEMASTERFORADMIN_FAILED,
        payload: data
    };
}

export { AddOrUpdateModulesMasterAdminLists, resetAddOrUpdateModuleMasterForAdminList }